import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { EnumMap } from "../../../library-js/tools/EnumMap";
import { Func, Func1 } from "../../../library-js/tools/TypeUtilities";
import { EnumValueField } from "./EnumValueField";
import { InspectorField } from "../fields/InspectorField";
import { InspectorCreationInfo } from "../InspectorCreationInfo";

export class EnumValue<E>
{
  protected _enumClass:any;
  get enumClass(){ return this._enumClass; }

  value:E;


  get enumMap()
  {
    return EnumValue._enumMaps.get( this._enumClass );
  }

  constructor( enumClass:any, value:E = undefined )
  {
    this._enumClass = enumClass;

    EnumValue._addMapFor( enumClass );

    if ( value )
    {
      this.value = value;
    }
    else
    {
      this.value = this.enumMap.keys[ 0 ] as any as E;
    }

    
  }

  private static _enumMaps = new Map<any,EnumMap>()
  private static _addMapFor( enumClass:any )
  {
    if ( ! EnumValue._enumMaps.has( enumClass ) )
    {      
      EnumValue._enumMaps.set( enumClass, EnumMap.create( enumClass ) );
      console.log( this._enumMaps );
    }
  }

  static createInspectorField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element )
  {
    let enumValue = info.object as EnumValue<any>;
    info.creator.addField( parentInfo, info, new EnumValueField( enumValue ), parent ); 
  }

  static defineEnumVisibilities<E>( field:InspectorField<any>, enumMemberName:string, 
                                    dependents:{[index:string]:E}, 
                                  )
  {

    let memberField = field.getChildField( enumMemberName );

    let updater = ()=>
    {
      let enumValue = memberField.info.object.value;

      for ( let it in dependents )
      {
        if ( ! dependents.hasOwnProperty( it ) )
        {
          continue;
        }

        let childField = field.getChildField( it );
        let container = childField.container;
        let visible = enumValue === dependents[ it ];

        ClassFlag.hidden.setAs( container, ! visible );
      }
    };

    memberField.onChange.addListener( updater );

    updater();
  }

}